import CopyUrl from "./CopyUrl";

export default CopyUrl;
